<button class="menu" mat-icon-button aria-label="Example icon-button with a menu">
    <mat-icon>menu</mat-icon>
</button>
<div class="container">
    <div class="chatbox">
        <div class="col-2 scroll-two">
            <h3>Liste des locations</h3>
            <ul>
                <!-- <li style="cursor: pointer;" class="online" *ngFor="let chat of listChatLodger"  (click)="currentRenting(chat.id, 'logder')">{{chat.renting_date_departure}} {{chat.renting_date_return}} ({{chat.mark_lib}} {{chat.mod_lib}})</li> -->
                <span *ngFor="let chat of listChat">
                    <li *ngIf="chat.id == idRenting" style="cursor: pointer;" class="online chat-active" (click)="currentRenting(chat.id, chat.prop_id)">{{chat.renting_date_departure}} {{chat.renting_date_return}} ({{chat.vehicle_mark}} {{chat.vehicle_model}})</li>
                    <li *ngIf="chat.id != idRenting" style="cursor: pointer;" class="online" (click)="currentRenting(chat.id, chat.prop_id)">{{chat.renting_date_departure}} {{chat.renting_date_return}} ({{chat.vehicle_mark}} {{chat.vehicle_model}})</li>
                </span>
            </ul>
        </div>
        <div class="col-1">
            <div class="scroll">
                <div *ngFor="let message of messages" >
                    <div class="msg-row" *ngIf="message.transmitter_id != user.id">
                        <div class="msg-text-user">
                            <h2 *ngIf="key == 'lodger' ? 'Locataire' : 'Propriètaire'"></h2>
                            <p>{{message.message_text}}</p>
                            <p style="text-align: end;">{{message.created_at | date:'short'}}</p>
                        </div>
                        <img src="assets/images/profile/julia.jpg" alt="User" class="msg-img">
                    </div>
                    <div class="msg-row msg-row2" *ngIf="message.transmitter_id == user.id">
                        <img src="assets/images/profile/ashley.jpg" alt="User" class="msg-img">
                        <div class="msg-text">
                            <h2>Moi</h2>
                            <p>{{message.message_text}}</p>
                            <p style="text-align: end;">{{message.created_at | date:'short'}}</p>
                        </div>
                    </div>
                </div>
            </div>
            <form [formGroup]="form" (ngSubmit)="sendMessage()" class="form-info">
                <input formControlName="message" type="text" placeholder="Tapez votre message ici..."/>
                <button type="submit" title="Envoyez le message">
                    <mat-icon class="icon">near_me</mat-icon>
                </button>
            </form>

        </div>
    </div>
</div>



